import { calculateDateRange } from "./calculateDateRange";

const getCorrectWordForm = (
  number: number,
  forms: [string, string, string]
): string => {
  const n = Math.abs(number) % 100;
  const n1 = n % 10;
  if (n > 10 && n < 20) return forms[2];
  if (n1 > 1 && n1 < 5) return forms[1];
  if (n1 === 1) return forms[0];
  return forms[2];
};

/**
 * * Получить строку с датой загрузки файла
 * @param date Дата загрузки
 * @returns
 */
export const getDateUploadString = (date: Date) => {
  const currentDate = new Date();
  if (currentDate.getTime() < date.getTime()) {
    console.error("Дата загрузки не может быть больше текущей");
    return;
  }
  // Текущий день
  const isCurrentDay =
    date.getFullYear() === currentDate.getFullYear() &&
    date.getMonth() === currentDate.getMonth() &&
    date.getDate() === currentDate.getDate();

  if (isCurrentDay) {
    return `${date.getHours().toString().padStart(2, "0")}:${date
      .getMinutes()
      .toString()
      .padStart(2, "0")}`;
  }

  const { minutes, hours, days, months, years } = calculateDateRange(
    date,
    currentDate
  );

  if (years > 0) {
    const yearsWord = getCorrectWordForm(years, ["год", "года", "лет"]);
    return `${years} ${yearsWord} назад`;
  }

  if (months > 0) {
    const monthsWord = getCorrectWordForm(months, [
      "месяц",
      "месяца",
      "месяцев",
    ]);
    return `${months} ${monthsWord} назад`;
  }

  if (days > 0) {
    const daysWord = getCorrectWordForm(days, ["день", "дня", "дней"]);
    return `${days} ${daysWord} назад`;
  }

  if (hours > 0) {
    const hoursWord = getCorrectWordForm(hours, ["час", "часа", "часов"]);
    return `${hours} ${hoursWord} назад`;
  }

  const minutesWord = getCorrectWordForm(minutes, [
    "минуту",
    "минуты",
    "минут",
  ]);
  return `${minutes} ${minutesWord} назад`;
};
